import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import { MENU_ID_FOR_YOU, MENU_ID_TEAMS, MENU_ID_YOUR_WORK } from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

// TODO: Remove your-work when cleaning up blu-7514_update_jira_home_your_work_to_for_you
const routes = new Set<RouteName>(['your-work', 'for-you', 'people-index']);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName = routeContext.route.name;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;
	// TODO: Remove your-work when cleaning up blu-7514_update_jira_home_your_work_to_for_you
	switch (routeName) {
		case 'your-work':
			path.push(MENU_ID_YOUR_WORK);
			break;
		case 'for-you':
			path.push(MENU_ID_FOR_YOU);
			break;
		case 'people-index':
			path.push(MENU_ID_TEAMS);
			break;
		default:
	}

	return path;
}

export const topLevelConverter = { routes, convert, convertNew };
